import {
  NhanVienEntity,
  PhongBanEntity,
  XeEntity,
} from '../../../../../server-api-hrm.type'
import { BASE_URL } from '../../../../../utils/config.base-url'

export const PHIEU_DAT_XE_PREFIX_URL = '/phieu-dat-xe'
export const PHIEU_DAT_XE_WAITING_APPROVAL_PREFIX_URL = `${PHIEU_DAT_XE_PREFIX_URL}/waiting-approval`
export const PHIEU_DAT_XE_APPROVED_PREFIX_URL = `${PHIEU_DAT_XE_PREFIX_URL}/approved`
export const PHIEU_DAT_XE_REPORT_PREFIX_URL = `${PHIEU_DAT_XE_PREFIX_URL}/report`
export const PHIEU_DAT_XE_CALENDAR_PREFIX_URL = `${PHIEU_DAT_XE_PREFIX_URL}/calendar`

export const URL_ENDPOINT_PHIEU_DAT_XE = `${BASE_URL}/phieu-dat-xe`
export const URL_ENDPOINT_PHIEU_DAT_XE_APPROVAL_LOG = `${BASE_URL}/phieu-dat-xe-approval-log/list/by-phieu-dat-xe`

export interface ReportDataByResource {
  id: string
  rec: XeEntity
  count: number
  percent: number
}

export type ReportNodeByPhongBan =
  | {
      id: string
      isParent: true
      rec: PhongBanEntity
      count: number
      percent: number
      children: (ReportNodeByPhongBan & { isParent: false })[]
    }
  | {
      id: string
      isParent: false
      rec: NhanVienEntity
      count: number
      percent: number
      children?: undefined
    }

export type ReportDataByPhongBan = ReportNodeByPhongBan & { isParent: true }
